import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';

const useStyles = makeStyles({
  root: {
    padding: 4,
    background: '#00000010',
  },
});

const ExcludeButton = ({ color, size, onClick }) => {
  const classes = useStyles();
  return (
    <IconButton className={classes.root} onClick={onClick}>
      <RemoveCircleOutlineIcon style={{ fontSize: size, color }} />
    </IconButton>
  );
};

ExcludeButton.defaultProps = {
  color: 'black',
  size: 18,
  onClick: () => {},
};

ExcludeButton.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  onClick: PropTypes.func,
};

export default ExcludeButton;
